import { IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';

function SelectInfo({ label, value, onChange, items }) {
    const handleReset = () => {
        onChange({ target: { value: '' } }); // Simule un changement à une valeur vide
    }

    return (
        <FormControl size="small" sx={{ width: '100%' }}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                label={label}
                onChange={onChange}
            >
                {items.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {value && ( // N'afficher la croix que si une valeur est sélectionnée
                <IconButton
                    aria-label="clear"
                    size="small"
                    onClick={handleReset}
                    style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}
                >
                    <ClearIcon />
                </IconButton>
            )}
        </FormControl>
    );
}

SelectInfo.propTypes = {
    label: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.any.isRequired,
    items: PropTypes.any.isRequired,
};

export default SelectInfo;